import { styled } from '@/lib/utils'

export const DetailsGrid = styled('div')(
  'grid gap-y-4 gap-x-6',
  'text-sm',
  'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
)
